module.exports = __webpack_public_path__ + "img/banner2.4a875d93.png";